<div class="m-t-15" *ngIf="descriptor">

    <vedrax-upload [descriptor]="descriptor" (uploadedFile)="handleUploadedFile($event)"></vedrax-upload>

    <div class="m-t-15 m-b-15" [ngClass]="uploadFile.file ? 'alert alert-info' : 'alert alert-warn'" *ngIf="uploadFile">
        {{uploadFile.file ? uploadFile.file.name : 'Echec du telechargement'}}
    </div>

</div>